// @ts-nocheck
import React, { useEffect, useState } from 'react'
import { useAppDispatch } from '../../hooks/useAppDispatch';
import { fetchApplicationDataDetails } from '../../store/slices/application/applicationSlice';
import { useParams } from 'react-router-dom';
import { formatDate } from 'date-fns';

function ApplicationDetail() {
  
  const [saveApplication, setSaveApplication] = useState(null);
  const [loading, setLoading] = useState(true); // <-- loading state
  const dispatch = useAppDispatch();
  const { base_slug, jobId, appId } = useParams();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true); // start loading
        const res = await dispatch(fetchApplicationDataDetails({ appId })).unwrap();
        setSaveApplication(res);
      } catch (error) {
        console.error('Error fetching application data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [dispatch, base_slug, jobId]);

  const formatSubmittedDate = (dateString) => {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      return formatDate(date, 'd MMMM yyyy'); // This will output "31 May 2025"
    } catch (error) {
      console.error('Date formatting error:', error);
      return dateString; // Return original string if formatting fails
    }
  };

  return (
    <div className="mt-[0px] px-4 lg:px-2 py-4 lg:py-[32px] h-[calc(100vh_-_115px)] overflow-y-auto">
      <div className="w-full max-w-[710px] mx-auto">
        <h2 className='text-[16px] lg:text-lg font-medium text-gray-900'>Application</h2>
        <div className='bg-[#e0e0e0] w-full h-[1px] mt-4 mb-[22px] lg:mb-[34px] lg:mt-7'></div>

        {loading ? (
            <div className="flex items-center justify-center h-[calc(100vh_-_380px)] w-full">
            <div className="simple-spinner-loader">
              <span></span>
            </div>
          </div>
        ) : (
          <div className="p-4 bg-green-100 text-green-800 border border-green-300 rounded-md relative">
            <div className="flex items-center gap-x-4 ">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="size-5"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
                />
              </svg>
              <div className="flex flex-col items-start gap-y-1">
                <span className="text-[13px] leading-4 font-normal text-green-800 w-full">
                  Application ID:<span className="ml-1">{saveApplication?.id}</span>
                </span>
                {saveApplication?.submitted_at && (
                  <p className="text-[13px] leading-4 font-normal text-green-800 w-full">
                    Submitted: <span>{formatSubmittedDate(saveApplication?.submitted_at)}</span>
                  </p>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default ApplicationDetail;
